
<template>
  <tbody style="cursor: pointer;">
    <v-menu
      offset-y
      max-width="200"
      nudge-right="100"
      :close-on-content-click="false"
      v-model="menu[booking.id.toString()]"
      v-if="booking != null"
    >
      <template v-slot:activator="{ on }">
        <tr
          v-on="on"
          v-if="booking != null"
          :id="taxi.id"
          valign="top"
          @click="setSelectedBooking(booking.id, -1);"
          v-bind:style="colorForTaxi(taxi, 'left')"
        >
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="fixed-table-row">
                  <span v-on="on">
                    <b>{{taxi.driver.callsign}}</b>
                    {{shortName(taxi.driver.name)}}
                  </span>
                </div>
              </template>
              <p v-html="tooltipForTaxi(taxi)"></p>
            </v-tooltip>
          </td>
          <td
            v-bind:style="colorForTaxi(taxi, 'right')"
          >{{timeForBooking(booking.pickup_time, booking.asap)}}</td>
          <td>
            {{etaForBooking}}m
            <b>{{ booking.pob_time == null ? ("/" + etaDate(etaForBooking)) : ""}}</b>
          </td>
          <td>
            <div class="fixed-table-row">{{prettify(booking.pickup_location.description)}}</div>
          </td>
          <td>
            <ViasForBooking :booking="booking" />
          </td>
          <td>
            <div class="fixed-table-row">{{destinationForBooking(booking)}}</div>
          </td>
          <td>
            <div class="fixed-table-row">{{nameOrRoomForCustomerForBooking(booking)}}</div>
          </td>
          <td>
            <AttributesForBookingCell :booking="booking" />
          </td>
        </tr>
      </template>
      <BookingMenu
        @copy="copy(booking)"
        @edit="edit(booking.id)"
        @close="menu[booking.id.toString()] = false"
        @track="setSelectedTaxi(taxi.id)"
        @reassign="reassign(booking.id)"
        :booking="booking"
      />
    </v-menu>
    <v-menu
      v-if="taxi.followOnJobs != null"
      v-for="(booking, index) in followOnJobsForTaxi"
      offset-y
      max-width="200"
      nudge-right="100"
      :close-on-content-click="false"
      v-model="menu[booking.id.toString()]"
    >
      <template v-slot:activator="{ on }">
        <tr
          v-on="on"
          valign="top"
          v-bind:style="colorForFollowOn(booking)"
          @click="setSelectedBooking(booking.id, -1);"
        >
          <td v-bind:style="colorForTaxiFollowOn(taxi, 'left', booking)">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="fixed-table-row">
                  <span v-on="on">
                    <b>{{taxi.driver.callsign}}</b>
                    &nbsp;{{index + 1}}
                  </span>
                </div>
              </template>
              <p v-html="tooltipForTaxi(taxi)"></p>
            </v-tooltip>
          </td>
          <td
            v-bind:style="colorForTaxiFollowOn(taxi, 'right', booking)"
          >{{timeForBooking(booking.pickup_time, booking.asap)}}</td>
          <td>
            {{etaForFollowOnBooking(booking)}}m
            <b>{{ booking.pob_time == null ? ("/" + etaTimeForFollowOnBooking(booking)) : ""}}</b>
          </td>
          <td>
            <div class="fixed-table-row">{{prettify(booking.pickup_location.description)}}</div>
          </td>
          <td>
            <ViasForBooking :booking="booking" />
          </td>
          <td>
            <div class="fixed-table-row">{{destinationForBooking(booking)}}</div>
          </td>
          <td>
            <div class="fixed-table-row">{{nameOrRoomForCustomerForBooking(booking)}}</div>
          </td>
          <td>
            <AttributesForBookingCell :booking="booking" />
          </td>
        </tr>
      </template>
      <BookingMenu
        @copy="copy(booking)"
        @edit="edit(booking.id)"
        @close="menu[booking.id.toString()] = false"
        @track="setSelectedBooking(booking.id, taxi.id)"
        @reassign="reassign(booking.id)"
        :booking="booking"
      />
    </v-menu>
  </tbody>
</template>

<script>
import BookingMenu from "@/components/widget/menu/BookingMenu.vue";

import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

export default {
  name: "ActiveTaxiTableRow",
  components: {
    AttributesForBookingCell,
    BookingMenu,
    ViasForBooking
  },
  props: {
    taxi: Object,
    selectedTaxi: Number,
    selectedBooking: Number,
    setSelectedTaxi: Function,
    setSelectedBooking: Function
  },
  computed: {
    booking: function() {
      if (this.taxi.currentBookingTaxi != null) {
        var booking = this.taxi.currentBookingTaxi.booking;
        // modify booking to have reference to current taxi -- used for assign trip
        booking.currentTaxi = this.taxi;
        return booking;
      } else {
        console.log("No current booking taxi??");
        return null;
      }
    },
    etaForBooking: function() {
      if (this.taxi.currentBookingTaxi != null) {
        return this.minutesToHoursMinutesString(
          this.taxi.currentBookingTaxi.taxi.eta
        );
      }
    },
    followOnJobsForTaxi: function() {
      return this.taxi.followOnJobs;
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: {}
    };
  },
  methods: {
    copy: function(booking) {
      this.$emit("copy", booking);
    },
    edit: function(bookingID) {
      this.$emit("edit", bookingID);
    },
    reassign: function(b) {
      this.$emit("reassign", b);
    },
    etaForFollowOnBooking: function(booking) {
      for (var i = 0; i < booking.follow_on_taxis.length; i++) {
        var taxi = booking.follow_on_taxis[i];
        if (taxi.eta != null) {
          return this.minutesToHoursMinutesString(taxi.eta);
        }
      }
      return "";
    },
    etaTimeForFollowOnBooking: function(booking) {
      for (var i = 0; i < booking.follow_on_taxis.length; i++) {
        var taxi = booking.follow_on_taxis[i];
        if (taxi.eta != null) {
          return moment(new Date())
            .add(taxi.eta, "minutes")
            .format("HH:mm");
        }
      }
      return "";
    },
    timeForBooking: function(timeString, asap) {
      var time = moment(timeString, "DD/MM/YYYY HH:mm");

      var timeFormatted = `${time.format("HH:mm")}`;

      if (asap == true) {
        timeFormatted = timeFormatted;
      }

      return timeFormatted;
    },
    etaDate: function(eta) {
      if (this.taxi.currentBookingTaxi != null) {
        return moment(new Date())
          .add(eta, "minutes")
          .format("HH:mm");
      }
    },
    minutesToHoursMinutesString: function(minutes) {
      var duration = moment.duration(minutes, "minutes");

      if (minutes == 0) {
        return 0;
      }

      var hoursMinutesString = Overwatch.durationToHoursMinutesString(
        duration,
        ""
      );

      return hoursMinutesString;
    },
    colorForTaxi: function(taxi, side) {
      var ow = new Overwatch(
        [this.taxi],
        [this.taxi.currentBookingTaxi.booking]
      );

      var style = { backgroundColor: ow.colorForTaxi(taxi) };

      if (taxi.in_emergency) {
        style.backgroundColor = "red";
      }

      if (side == "right") {
        style.paddingRight = "3px";
      }

      if (this.selectedTaxi == taxi.id) {
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.2)";
      }

      return style;
    },
    colorForFollowOn: function(booking) {
      var style = {};

      if (this.selectedBooking == booking.id) {
        // style.backgroundColor = "red";
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.1)";
      }

      return style;
    },
    colorForTaxiFollowOn: function(taxi, side, booking) {
      var ow = new Overwatch([this.taxi], null);

      var style = { backgroundColor: ow.colorForFollowOnTaxi(taxi, booking) };

      if (taxi.in_emergency) {
        style.backgroundColor = "red";
      }

      if (side == "right") {
        style.paddingRight = "3px";
      }

      return style;
    },
    prettify: function(d) {
      return Overwatch.prettifyAddress(d);
    },
    destinationForBooking: function(b) {
      return Overwatch.destinationForBooking(b);
    },
    shortName: function(d) {
      return d.substring(0, 10);
    },
    nameOrRoomForCustomerForBooking: function(b) {
      var name = Overwatch.nameForCustomerForBooking(b);

      if (b.business_customer_name != null && b.business_customer_name != "") {
        return b.business_customer_name;
      } else if (b.room_number != null && b.room_number != "") {
        return b.room_number;
      } else {
        return b.customer_name;
      }
    },
    tooltipForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.tooltipForTaxi(taxi);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.fixed-table-row {
  overflow: hidden;
  height: 16px;
}
</style>
